import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { buildShipDateColorMap } from "@/lib/shipDateColors";
import type { ShipDateColorSlot } from "@/lib/shipDateColors";

/**
 * Shared hook: fetches /api/inventory/upcoming-ship-dates (future dates only)
 * and returns a stable date→color-slot map that is the same across all views.
 */
export function useShipDateColorMap(): Map<string, ShipDateColorSlot> {
  const { data } = useQuery<{ dates: string[] }>({
    queryKey: ["/api/inventory/upcoming-ship-dates"],
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return useMemo(
    () => buildShipDateColorMap(data?.dates ?? []),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(data?.dates ?? [])]
  );
}
